<section
  class="newsletter"
  [ngClass]="{
    'newsletter-compact': compact
  }"
>
  <div class="newsletter-container cm-surface-box-blue-with-shapes">
    <div class="newsletter-content">
      <div class="newsletter-grid">
        <img src="/assets/img/homepage/envelope.png" class="newsletter-image" />
        <h2 class="newsletter-heading" [innerHTML]="heading"></h2>
        <p class="newsletter-paragraph" [innerHTML]="text"></p>
        <div class="newsletter-form-wrapper">
          <form [formGroup]="newsletterForm" (ngSubmit)="onSubmit()" class="newsletter-form">
            <app-input
              [size]="'small'"
              [placeholder]="'shared.common.email-placeholder' | translate"
              [formControlName]="'email'"
              [hasSuccess]="formState === ApiStateStatus.success"
              [hasError]="formState === ApiStateStatus.error"
              [ngClass]="{
                'sm:max-w-[312px]': !compact
              }"
              class="flex-1"
              type="email"
            >
              <svg-icon src="/assets/icons/16/alternate-email.svg" app-input-addons-left-inside></svg-icon>
            </app-input>
            <re-captcha
              #recaptchaRef
              [siteKey]="recaptchaSiteKey"
              (resolved)="recaptchaResolved($event)"
              size="invisible"
            ></re-captcha>
            <app-action-button
              *ngIf="formState !== ApiStateStatus.success"
              [facet]="'secondary'"
              [size]="'small'"
              [disabled]="newsletterForm.invalid"
              [waiting]="formState === ApiStateStatus.loading"
              [label]="(firstAttempt ? 'shared.newsletter.subscribe' : 'shared.newsletter.subscribe-again') | translate"
              [appearance]="'shrink-0'"
              [isFullWidth]="compact"
              type="submit"
            ></app-action-button>
          </form>
          <div *ngIf="formState === ApiStateStatus.success" class="newsletter-form-result">
            <svg-icon src="/assets/icons/16/checkmark-circle.svg"></svg-icon>
            <span class="max-w-[420px]">{{ 'shared.newsletter.success' | translate }}</span>
          </div>
          <div *ngIf="formState === ApiStateStatus.error" class="newsletter-form-result">
            <svg-icon src="/assets/icons/16/warning.svg"></svg-icon>
            <span class="max-w-[420px]">{{ 'shared.newsletter.error' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
